import { render, staticRenderFns } from "./LivraisonComponent.vue?vue&type=template&id=e4b7604c"
import script from "./LivraisonComponent.vue?vue&type=script&lang=js"
export * from "./LivraisonComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitnami/deploy/oscar_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4b7604c')) {
      api.createRecord('e4b7604c', component.options)
    } else {
      api.reload('e4b7604c', component.options)
    }
    module.hot.accept("./LivraisonComponent.vue?vue&type=template&id=e4b7604c", function () {
      api.rerender('e4b7604c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/livraison/LivraisonComponent.vue"
export default component.exports